/* Lystige — Preview v1 · JS minimal, sans tracker, accessible. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function toggle(el, open) {
    if (!el) return;
    el.setAttribute('data-open', open ? 'true' : 'false');
  }

  // --- Panneaux (menu mobile + panier) : ouverture/fermeture accessibles ---
  function wirePanel(openSelector, panelId, overlayId) {
    var panel = document.getElementById(panelId);
    var overlay = overlayId ? document.getElementById(overlayId) : null;
    if (!panel) return;
    var openers = document.querySelectorAll(openSelector);
    var closers = panel.querySelectorAll('[data-close]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      toggle(panel, true); if (overlay) toggle(overlay, true);
      document.documentElement.style.overflow = 'hidden';
      var f = panel.querySelector('a,button,input');
      if (f) f.focus();
    }
    function close() {
      toggle(panel, false); if (overlay) toggle(overlay, false);
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('data-open') === 'true') close();
    });
    panel._raptiClose = close;
  }

  wirePanel('[data-open-menu]', 'MobileMenu', 'MobileMenuOverlay');
  wirePanel('[data-open-cart]', 'CartDrawer', 'CartDrawerOverlay');

  // --- Révélation au défilement (seulement si autorisée) ---
  // Rejoué à chaque rendu de section : sinon le contenu réinjecté par l'éditeur
  // de thème n'est jamais observé et reste bloqué à opacity:0.
  var io = null;
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-reveal]');
    if (!reduceMotion && document.body.classList.contains('anim-on') && 'IntersectionObserver' in window) {
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      }
      els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  initReveal();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); loadRecommendations(e.target); });

  // --- Recommandations produit (chargées en différé via l'API Shopify) ---
  function loadRecommendations(scope) {
    var nodes = (scope || document).querySelectorAll('[data-product-recommendations]');
    nodes.forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html')
            .querySelector('[data-product-recommendations]');
          if (!fresh || !fresh.innerHTML.trim()) return;
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
        })
        .catch(function () { /* pas de recommandation : on laisse le conteneur vide */ });
    });
  }
  loadRecommendations();

  // --- Sélecteur de variantes ---
  // Les <select> d'options ne sont PAS postés : ils pilotent l'input caché « id ».
  // Sans ça, Shopify ignore les options et ajoute toujours la première variante.
  function initVariantPicker(scope) {
    (scope || document).querySelectorAll('[data-variant-picker]').forEach(function (root) {
      if (root.dataset.wired) return;
      root.dataset.wired = '1';
      var dataEl = root.querySelector('[data-variant-data]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!Array.isArray(variants) || !variants.length) return;

      var form = root.closest('form');
      if (!form) return;
      var idInput = form.querySelector('[data-variant-id]');
      var btn = form.querySelector('[data-add-button]');
      var priceEl = document.querySelector('[data-product-price]');
      var selects = root.querySelectorAll('select[data-option-index]');

      function update() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
          if (ok) { match = v; break; }
        }
        if (!match) {
          if (btn) { btn.disabled = true; btn.textContent = btn.dataset.labelSold || 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price) priceEl.textContent = match.price;
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? (btn.dataset.labelAdd || 'Add to cart') : (btn.dataset.labelSold || 'Unavailable');
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }
  initVariantPicker();
  document.addEventListener('shopify:section:load', function (e) { initVariantPicker(e.target); });

  // --- Retour en haut ---
  var toTop = document.getElementById('ToTop');
  if (toTop) {
    var onScroll = function () { toTop.classList.toggle('is-visible', window.scrollY > 600); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  // --- Panier : compteur + rafraîchissement du drawer après ajout (Ajax natif Shopify) ---
  function updateCartCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = cart.item_count; n.hidden = cart.item_count === 0;
    });
  }

  // Rafraîchit le contenu du drawer (lignes, sous-total, barre de livraison offerte,
  // badges de paiement) en re-rendant le Liquid côté serveur : source unique de vérité.
  function refreshCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.fetch) return Promise.resolve();
    return fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        if (!fresh) return;
        drawer.innerHTML = fresh.innerHTML;
        // Re-brancher les fermetures sur les nœuds fraîchement injectés.
        if (drawer._raptiClose) {
          drawer.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', drawer._raptiClose); });
        }
      })
      .catch(function () { /* on garde l'ancien contenu si l'appel échoue */ });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    if (!window.fetch) return; // repli : soumission standard
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCounts(cart);
        var opener = document.querySelectorAll('[data-open-cart]')[0];
        return refreshCartDrawer().then(function () {
          if (document.getElementById('CartDrawer') && opener) opener.click();
        });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
})();
